import { IconInfo } from '../components/WebLink/WebLink';
import { LinkIconName } from '../components/types';
import { LinkIconPlacement } from '@property.com.au/ui-kit';

type ApiIconInfoName = LinkIconName;
type ApiIconInfoPlacement = 'LEFT' | 'RIGHT' | null;

const mapPlacement = (placement: ApiIconInfoPlacement): LinkIconPlacement | null => {
  switch (placement) {
    case 'LEFT':
      return 'left';
    case 'RIGHT':
      return 'right';
    default:
      return null;
  }
};

export const mapApiWeblinkIconInfoToLinkIconInfo = ({
  name,
  placement,
}: {
  name: ApiIconInfoName;
  placement: ApiIconInfoPlacement;
}): IconInfo => {
  return {
    name,
    placement: mapPlacement(placement),
  };
};
